<div class="p-3 rounded-3">
  <div class="row mb-2">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/error-log.png" alt="error-log" onkeydown="" />
        </div>
        <h3>{{ "Error Logs" }}</h3>
      </div>
    </div>
    <div class="row position">
      <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
        <div class="col-md-2">
          <div class="srchgrid texttarget">
            <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)" [value]="searchString"
              placeholder="Search" autocomplete="off">
            <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                aria-hidden="true">&times;</span> </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position">
    <kendo-grid #grid [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false" [sort]="sort"
      (sortChange)="gridData ? sortChange($event): null" [resizable]="true" [reorderable]="true" filterable="menu"
      [filter]="state.filter" [selectable]="true" (dataStateChange)="gridData ? dataStateChange($event): null"
      [navigable]="true" [height]="gridHeight">
      <kendo-grid-column field="Message" title="Message" [width]='30'>
      </kendo-grid-column>
      <kendo-grid-column field="Source" title="Source" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="User" title="User" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="TimeUtc" title="Date" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="" title="Action" [width]='20'>
        <ng-template kendoGridCellTemplate let-dataItem>
          <img alt="view" onkeydown="" (click)="openDialogWithTemplateRef(detailPage, dataItem)" matTooltip="View"
            src="./assets/image/view-icon.png" class="ico20 mr-2" />
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
<ng-template #detailPage>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">
          Error Detail Page
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <div class="row mt-2">
          <div class="col-2">
            <label><b>Message:</b></label>
          </div>
          <div class="col-10">
            <label>{{selectdErrorData.Message}}</label>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <label><b>Source:</b></label>
          </div>
          <div class="col-10">
            <label>{{selectdErrorData.Source}}</label>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <label><b>User:</b></label>
          </div>
          <div class="col-10">
            <label>{{selectdErrorData.User}}</label>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <label><b>Date:</b></label>
          </div>
          <div class="col-10">
            <label>{{selectdErrorData.TimeUtc | date: 'dd-MM-yyyy'}}</label>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <label><b>AllXml:</b></label>
          </div>
          <div class="col-10" style="border: 1px solid #80808075 !important; border-radius: 9px;">
            <textarea style="margin: 2px; padding: 2px;" matInput readonly cols="100"
              rows="10"> {{selectdErrorData.AllXml}}</textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>